import { useTranslate } from '@va/localization';
import { BusinessInfoType } from '@va/types/account';
import { fontWeights, Paragraph, ProgressBar } from '@va/ui/design-system';

type BusinessInfoCompletionProps = { className?: string; businessInfo: BusinessInfoType | undefined };

const completionPercentages: Record<keyof BusinessInfoType, number> = {
  id: 0,
  businessSector: 10,
  businessSize: 10,
  businessType: 10,
  city: 10,
  companyName: 10,
  companyWebsite: 10,
  country: 10,
  firstName: 5,
  lastName: 5,
  state: 5,
  street: 5,
  vat: 5,
  zipcode: 5,
};

export const BusinessInfoCompletion = ({ className, businessInfo }: BusinessInfoCompletionProps) => {
  const translate = useTranslate();

  const percentage = Object.entries(businessInfo ?? {}).reduce((acc, [key, value]) => {
    if (value) return acc + (completionPercentages[key as keyof BusinessInfoType] ?? 0);

    return acc;
  }, 0);

  return (
    <div className={className}>
      <Paragraph weight={fontWeights.semibold} className='mb-1.5' colorClassName='text-primary'>
        {translate('account.businessDetails.profileCompletion', { percentage })}
      </Paragraph>
      <ProgressBar progress={[{ color: 'var(--color-primary)', percentage }]} />
    </div>
  );
};
